import React, {useEffect, useMemo} from 'react';

import styles from './DesktopModal.module.css'

import {closeIcon} from "../../../assets/icons/icons.ts";
import {useScreenDetector} from "../../../hooks/useScreenDetector.ts";
import {cn} from "../../../utils/cn.ts";
import {useClickOutside} from "../../../hooks/useClickOutside.tsx";
import {useKeydownHandler} from "../../../hooks/useKeydownHandler.tsx";

interface Props {
    isOpen: boolean
    close: () => void
    children: React.ReactNode
    title?: string|React.ReactNode
    type?: 'small' | 'big'
}

export const DesktopModal: React.FC<Props> = ({children, close, isOpen = false, title = '', type = 'big'}) => {
    const {isMobile} = useScreenDetector()
    const {containerRef} = useClickOutside(isOpen, () => close())

    useKeydownHandler(() => close())

    const isSmall = useMemo(() => type === 'small', [type])

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };

    }, [isOpen, isMobile]);


    return (<>
        {isOpen && (<>
            <div className='overlay'>
                <div
                    ref={containerRef}
                    className={cn(styles.modal, isSmall && styles.modalSmall)}
                >
                    <div className={styles.header}>
                        {title && <div className={styles.title}>{title}</div>}
                        <img className={styles.closeBtn} src={closeIcon} alt='Закрыть модал' onClick={close}/>
                    </div>
                    <div>
                        {children}
                    </div>
                </div>
            </div>
        </>)}
    </>);
};